/**
 * Assert certain properties in test mode
 * @module
 */
var _ = require('optimizely-client-fn');
var JSONEnv = require('../lib/json');
var schema = require('../types').schema;

var assert = function(expr, message) {
  if (!expr) {
    throw new Error(message);
  }
};

/**
 * Assert business-rule violations on a schematically-valid Layer
 * @param {Layer} layer
 */
exports.assertValidLayer = function(layer:Layer) {
  var errorPreamble = 'Validation error on layer "' + layer.id + '": ';

  if (layer.policy === 'random') {
    assert(layer.experiments.length === 1 || !_.isUndefined(layer.weightDistributions),
           errorPreamble + 'Layer with "random" policy and multiple experiments must have "weightDistributions" property.');
  }

  _.each(layer.experiments, function(experiment) {
    if (experiment.variations.length > 1) {
      assert(!_.isUndefined(experiment.weightDistributions),
             errorPreamble + 'experiment "' + experiment.id + '" with >1 variations must have weightDistributions property.');
    }
  });
};

/**
 * @param {string} typeName defined in types.schema[typeName]
 * @param {*} toCheck
 * @param {string} errorMsg
 */
exports.isType = function(typeName:string, toCheck:any, errorMsg:string) {
  var checkFn = schema[typeName];
  if (!checkFn) {
    throw new Error('No type defined for ' + typeName);
  }

  var isValid = checkFn(toCheck);
  if (!isValid) {
    var errorObj = checkFn.errors(toCheck);
    var errorString = 'INVARIANT: TypeError for type="' + typeName + '"';
    if (errorMsg) {
      errorString += ' ' + errorMsg;
    }
    errorString += '\n' + JSONEnv.stringify(errorObj, null, 2);
    throw new Error(errorString);
  }
};
